import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { HhsgSharedFileImport } from '../models/file-import.model';
import { Observable, defer } from 'rxjs';
import DevExpress from 'devextreme';
import { HhsgSharedFileImportDetail } from '../models/file-import-details.model';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HhsgSharedHttpService } from './http.service';
import { HhsgSharedConfigService } from './config.service';

@Injectable()
export class HhsgSharedImporterService {
    private readonly _apiServer: string;
	constructor(
        private _configService: HhsgSharedConfigService,
        private _oidcSecurityService: OidcSecurityService,
        private _httpService: HhsgSharedHttpService) {
            this._apiServer = _configService.appSettings.stsServer;
	}

	async hasAwsRegionBeenConfigured(): Promise<boolean> {
		return this._httpService.doGetRequestAsync<boolean>(this._apiServer,'Importer', 'HasAwsRegionBeenConfigured');
	}

	async saveFileToS3(formData: FormData, clientId: number, applicationId: number): Promise<HhsgSharedFileImport> {
		const params = new HttpParams()
			.set('clientId', clientId.toString())
			.set('applicationId', applicationId.toString());
			
		return this._httpService.doMultiPartPostRequestWithParamsAsync(this._apiServer,'Importer', 'SaveFileToS3', formData, params);
	}

	getFileImportsDataStoreByApplication(applicationAbbreviation : string): Observable<DevExpress.data.CustomStore> {
		const url = `${this._apiServer}/Importer/GetFileImportsByApplication`;

		return defer(() => this._httpService.createASPDataStore({ loadUrl: url, key: 'id',loadParams: { applicationAbbreviation : applicationAbbreviation }}));
	}

	getFileImportDetailsDataStore(id: number): any {
		const url = `${this._apiServer}/Importer/GetFileImportDetails`;

		return defer(() => this._httpService.createASPDataStore({ loadUrl: url, key: 'id', loadParams: { fileImportId : id }}));
	}


	async getUpdatedFileImports(lastUpdatedUtc: string): Promise<HhsgSharedFileImport[]> {
		const params = new HttpParams()
			.set('lastUpdatedUtc', lastUpdatedUtc);
			
		return this._httpService.doGetRequestWithParamsAsync<HhsgSharedFileImport[]>(this._apiServer,'Importer', 'GetUpdatedFileImports', params);
	}

	async getFileImportDetails(fileImportId: number): Promise<HhsgSharedFileImportDetail[]> {
		const params = new HttpParams()
			.set('fileImportId', fileImportId.toString());
			
		return this._httpService.doGetRequestWithParamsAsync<HhsgSharedFileImportDetail[]>(this._apiServer,'FileImport', 'GetFileImportDetails', params);
	}
}